// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"123":"cc8ed755a2207810","806":"b6db9a5bfcb10d4c"}[chunkId] + ".js";
};